// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDataFound_wrapper__+Rhdo","title":"NoDataFound_title__yCzJp","content":"NoDataFound_content__NkIs6"};